var map = {
	"./BuildinLayoutLeft.vue": 70980,
	"./BuildinLayoutTop.vue": 10970,
	"./BuildinLayoutTopLeft.vue": 42399,
	"./BuildinLayoutTopLeftDouble.vue": 68837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21660;